module.exports = __webpack_public_path__ + "img/current_hub_line_down.98ec3624.png";